import React from 'react';
import { cx, withStyles } from '../../utils/tss';

import BaseButton from '@mui/material/Button';

const styles = theme => ({
  root: {},
  label: {},
  disabled: {},
  bigButton: {
    textTransform: 'uppercase',
    padding: theme.spacing(1.5),
    width: '100%',
  },
});

const Button = withStyles(function Button(props) {
  const { classes, className, big, children, ...rest } = props;
  const { bigButton, ...others } = classes;
  return (
    <BaseButton className={cx(big && bigButton, className)} classes={others} {...rest}>
      {children}
    </BaseButton>
  );
}, styles);

export default Button;
